import { Component, input, model, output, TemplateRef } from '@angular/core';
import type {
  TTableAction,
  TTableActionOutput,
  TTableColumn,
  TTableRenderComponent,
} from '@dss-libs/shared/type/common-types';

@Component({
  template: '',
})
export abstract class BaseTableComponent<T, A> {
  readonly columns = input.required<TTableColumn<T>[]>();
  readonly data = input.required<T[]>();
  readonly showHeader = input(true);
  readonly menuActions = input<TTableAction<A, T>[]>([]);
  readonly buttonActions = input<TTableAction<A, T>[]>([]);
  readonly isRowClickable = input(false);
  readonly rowKeyFn = input<(row: T) => unknown>((row) => row);
  readonly initialExpansionFn = input<(row: T) => number>(() => 0);
  readonly expandedDetails = input<TemplateRef<unknown> | TTableRenderComponent<T, unknown>>();
  readonly selectedRows = model<T[] | undefined>(undefined);

  readonly actionOutput = output<TTableActionOutput<T, A>>();
  readonly rowClickOutput = output<T>();
}
